import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "../../../../Component/CSS/SearchFilterStyle.css";

class FeedbackFilter extends Component {
  render() {
    const { classes, data, handleChange } = this.props;
    return (
      <div>
        <div style={{ fontSize: 16 }}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="date"
            type="date"
            label="Date "
            fullWidth
            margin="normal"
            variant="outlined"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.date}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(FeedbackFilter);
